module.exports = __webpack_public_path__ + "static/scheme-999ec7c8adcef47c959fb5db8d657508.png";